import { map } from 'lodash/fp';
import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Grid, Stack, Typography } from '@mui/material';
import {
  EmailTwoTone,
  LocalPhoneTwoTone,
  PermPhoneMsgTwoTone,
} from '@mui/icons-material';
import { Caption } from './material-theme';
import { useAxios } from './util/use-axios';
import { IFIBreadcrumbs } from './Breadcrumbs';
import { StudentSkeleton } from './Skeleton/StudentSkeleton';

const StudentDetails = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { loading, axiosHttp } = useAxios();
  const [detail, setDetail] = useState({});

  if (!props.match.params.id) {
    enqueueSnackbar(
      'An error occurred to show student details. Please try it again.',
      { variant: 'error' },
    );
    props.history.push('/requests');
  }

  const getStudentDetail = () =>
    axiosHttp(`/api/student/${props.match.params.id}`)
      .then((result) => setDetail(result.data))
      .catch((err) => enqueueSnackbar(err.message, { variant: 'error' }));

  useEffect(getStudentDetail, [
    props.match.params.id,
    enqueueSnackbar,
    axiosHttp,
  ]);

  const {
    Name,
    Home_Country__c,
    Address_of_Permanent_Housing__c,
    MobilePhone,
    Email,
    Student_Campus__c,
    Degree_Level__c,
  } = detail;

  const layout = [
    {
      title: 'Name',
      body: Name,
    },
    {
      title: 'Country',
      body: Home_Country__c,
    },
    {
      title: 'Mobile',
      body: MobilePhone || 'N/A',
      customContent: MobilePhone && (
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            size="small"
            target="blank"
            href={`tel:${MobilePhone}`}
            endIcon={<LocalPhoneTwoTone />}
          >
            Call
          </Button>
          <Button
            variant="outlined"
            size="small"
            target="blank"
            href={`sms:${MobilePhone}`}
            endIcon={<PermPhoneMsgTwoTone />}
          >
            Text
          </Button>
        </Stack>
      ),
    },
    {
      title: 'Email',
      body: Email,
      customContent: (
        <Button
          variant="outlined"
          size="small"
          target="blank"
          href={`mailto:${Email}`}
          endIcon={<EmailTwoTone />}
        >
          Email
        </Button>
      ),
    },
    {
      title: 'Campus',
      body: Student_Campus__c,
    },
    {
      title: 'Level',
      body: Degree_Level__c,
    },
    {
      title: 'Address',
      body: Address_of_Permanent_Housing__c ?? 'N/A',
      spaceCount: { xs: 12 },
    },
  ];

  return loading ? (
    <StudentSkeleton />
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <IFIBreadcrumbs
          breadcrumbs={[
            { href: '/requests', name: 'Student Requests' },
            { name: Name },
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">{Name}</Typography>
      </Grid>
      {map(
        ({ title, body, customContent, spaceCount = { xs: 6 } }) => (
          <Grid item {...spaceCount} key={title}>
            <Caption>{title}</Caption>
            <Typography>{body}</Typography>
            {customContent}
          </Grid>
        ),
        layout,
      )}
    </Grid>
  );
};

export { StudentDetails };
